(function($) {
	$(document).ready(function() {

		$('.portfolio-filter form select').on('change', function(ev) {
 			ev.preventDefault();
 			portfolioFilter();
 		});

 		$('.portfolio-filter form input[type="checkbox"]').on('change', function(ev) {
 			ev.preventDefault();
 			$('input[type="checkbox"]').not(this).prop('checked', false);
 			portfolioFilter();
 		});

		function portfolioFilter() {

			var type,
				form = $('.portfolio-filter form'),
				container = $('.portfolio-filter-container .portfolio');


			if(form.find('input[type="checkbox"]').is(':checked')) {
				type = form.find('input[type="checkbox"]:checked').val();
			} else {
				type = null;
			}

			var sectors = form.find('select[name="sect"]').val();
			var strategy = form.find('select[name="strat"]').val();

			console.log(strategy);

 			$.ajax({
				url: filter_people_obj.ajaxurl,
				type: 'post',
				data: {
					action: 'portfolio_filter',
					type : type,
					sectors : sectors,
					strategy : strategy,
				},
				beforeSend: function() {
					container.find('li').remove();
					$('.no-results').remove();
					$('#loading-icon').show();
				},
				success: function( result ) {
					container.append(result);
				},
				complete: function() {
					$('#loading-icon').slideUp();
				}
			});
		}

	});
})(jQuery);
